export const italian = {
  hero: {
    title: 'How Bistroo helped our Italian restaurant handle the rush and grow',
    description: 'Ristorante Il Municipio is a renowned Italian restaurant located in Twente, specializing in authentic pizzas and pastas. Their craftsmanship was recognized when they secured 1st place at the 2025 Dutch Pizza Baking Championships (NK Pizzabakken) during Horecava.'
  },
  testimonials: {
    1: {
      text: 'Bistroo really thought along with us and offered solutions that matched our needs and growing ambitions. New opportunities were quickly developed and implemented, leading to a seamless collaboration and improved customer service.',
      name: 'Jens Otterman',
      job_title: 'Restaurant Owner'
    },
    2: {
      text: 'Since switching to Bistroo, we no longer need to take phone orders, saving valuable time and allowing more focus on customer service.',
      name: 'Luc Fransen',
      job_title: 'Manager'
    }
  },
  challenge: {
    paragraph: {
      title: 'New solutions and opportunities',
      text: 'The restaurant is known for its passion for high-quality ingredients and traditional Italian cuisine. Il Municipio has been working with Bistroo for over two years and shares the challenges they faced before the partnership and the solutions Bistroo provided.'
    },
    paragraph_2: {
      title: 'The challenge',
      bullets: {
        1: 'During busy hours, Ristorante Il Municipio could become overwhelmed with orders, leading to longer wait times for both staff and customers.',
        2: 'Taking phone orders consumed a lot of staff time and sometimes led to errors or misunderstandings.        ',
        3: 'As a fast-evolving and growing business, Ristorante Il Municipio needed a flexible solution that could grow along with their changing needs.',
        4: ''
      }
    }
  },
  solution: {
    title: 'The solution',
    checklist: {
      1: 'Bistroo’s online ordering solution enabled Ristorante Il Municipio to send digital order confirmations to customers. Customers could check their orders for errors, improving accuracy and satisfaction.',
      2: 'By switching to Bistroo, the staff no longer had to take phone orders, saving valuable time that could be spent preparing delicious dishes and providing excellent service.',
      3: 'Bistroo collaborated with Ristorante Il Municipio to provide solutions that aligned with their evolving needs and growing ambitions. New ideas were quickly developed and implemented, resulting in seamless cooperation and improved customer service.',
      4: 'Bistroo was always available to support Ristorante Il Municipio, regardless of the time. This ongoing support gave the restaurant peace of mind and confidence in their online ordering process.'
    }
  },
  conclusion: {
    title: 'The conclusion',
    text: {
      1: 'Thanks to Bistroo’s online ordering solution, Ristorante Il Municipio was able to not only improve their operational efficiency but also enhance customer satisfaction and tap into growth opportunities. The restaurant especially appreciated the digital confirmation system and the time saved by eliminating phone orders.',
      2: 'As a partner that is available 24/7 and adapts to the restaurant’s needs, Ristorante Il Municipio highly recommends Bistroo to other hospitality businesses looking for a flexible and efficient online ordering solution.'
    }
  }
}
